import { useTranslation } from '@pancakeswap/localization'
import {
  Box,
  Flex,
  LogoutIcon,
  Text,
  UserMenu as UIKitUserMenu,
  UserMenuDivider,
  UserMenuItem,
  UserMenuVariant,
  useModal,
} from '@pancakeswap/uikit'
import ConnectWalletButton from 'components/ConnectWalletButton'
import { useActiveChainId } from 'hooks/useActiveChainId'
import useAuth from 'hooks/useAuth'
import { useDomainNameForAddress } from 'hooks/useDomain'
import { useCallback, useState } from 'react'
import { useAccount } from 'wagmi'
import WalletModal, { WalletView } from './WalletModal'
import WalletUserMenuItem from './WalletUserMenuItem'

const WHITELIST_CHAIN = [1975, 137, 56]
// const WHITELIST_CHAIN = [1975, 137]

const UserMenuItems = () => {
  const { t } = useTranslation()
  const { isWrongNetwork, chainId } = useActiveChainId()
  const { logout } = useAuth()

  const [onPresentWalletModal] = useModal(<WalletModal initialView={WalletView.WALLET_INFO} />)
  const [onPresentWrongNetworkModal] = useModal(<WalletModal initialView={WalletView.WRONG_NETWORK} />)

  const onClickWalletMenu = useCallback((): void => {
    if (isWrongNetwork) {
      onPresentWrongNetworkModal()
    } else {
      onPresentWalletModal()
    }
  }, [isWrongNetwork, onPresentWalletModal, onPresentWrongNetworkModal])

  return (
    <>
      <WalletUserMenuItem
        isWrongNetwork={isWrongNetwork || !WHITELIST_CHAIN.includes(chainId || 1975)}
        onPresentWalletModal={onClickWalletMenu}
      />
      {/* <UserMenuItem as="button" disabled={isWrongNetwork} onClick={onPresentTransactionModal}>
        {t('Recent Transactions')}
        {hasPendingTransactions && <RefreshIcon spin />}
      </UserMenuItem> */}
      {/* <UserMenuDivider />
      <NextLink href={`/profile/${account?.toLowerCase()}`} passHref>
        <UserMenuItem disabled={isWrongNetwork || chainId !== ChainId.BSC}>{t('Your NFTs')}</UserMenuItem>
      </NextLink> */}
      {/* {shouldShowModal && <ClaimYourNFT />}
      <ProfileUserMenuItem
        isLoading={isLoading}
        hasProfile={hasProfile}
        disabled={isWrongNetwork || chainId !== ChainId.BSC}
      /> */}
      <UserMenuDivider />
      <UserMenuItem as="button" onClick={logout}>
        <Flex alignItems="center" justifyContent="space-between" width="100%">
          <Text>{t('Disconnect')}</Text>
          <LogoutIcon />
        </Flex>
      </UserMenuItem>
    </>
  )
}

const UserMenu = () => {
  const { t } = useTranslation()
  const { address: account } = useAccount()
  const { avatar } = useDomainNameForAddress(account)
  const { isWrongNetwork } = useActiveChainId()
  const avatarSrc = avatar
  const [userMenuVariable, setUserMenuVariable] = useState<UserMenuVariant>('default')

  if (account) {
    return (
      <UIKitUserMenu account={account} ellipsis={!!account} avatarSrc={avatarSrc} text="" variant={userMenuVariable}>
        {({ isOpen }) => (isOpen ? <UserMenuItems /> : null)}
      </UIKitUserMenu>
    )
  }

  if (isWrongNetwork) {
    return (
      <UIKitUserMenu text={t('Network')} variant="danger">
        {({ isOpen }) => (isOpen ? <UserMenuItems /> : null)}
      </UIKitUserMenu>
    )
  }

  return (
    <div
      style={{
        background: '#1B222D',
        borderRadius: '0px 16px 16px 0px',
      }}
    >
      <ConnectWalletButton scale="sm">
        <Box display={['none', , , 'block']} style={{ color: '#090D17' }}>
          <Text
            color="#090D17"
            style={{
              fontSize: 14,
              fontWeight: 700,
            }}
          >
            {t('Connect Wallet')}
          </Text>
        </Box>
        <Box display={['block', , , 'none']} style={{ color: '#090D17' }}>
          <Text
            color="#090D17"
            style={{
              fontSize: 14,
              fontWeight: 700,
            }}
          >
            {t('Connect')}
          </Text>
        </Box>
      </ConnectWalletButton>
    </div>
  )
}

export default UserMenu
